import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiX, FiShield } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import './CookieConsent.css';

const STORAGE_KEY = 'astro_cookie_consent';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Small delay so banner doesn't flash on first paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ analytics: true, marketing: true, date: new Date().toISOString() }));
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ analytics: false, marketing: false, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-inner">
        <div className="cookie-header">
          <FiShield className="cookie-shield" />
          <span className="cookie-title">{t('cookie.title')}</span>
          <button className="cookie-close" onClick={acceptEssential} aria-label="Close">
            <FiX />
          </button>
        </div>

        <p className="cookie-text">
          {t('cookie.description')}
          {' '}
          <Link to="/privacy" className="cookie-link">{t('cookie.privacyPolicy')}</Link>
          {' · '}
          <button className="cookie-link-btn" onClick={() => setShowDetails(!showDetails)}>
            {showDetails ? t('cookie.hideDetails') : t('cookie.cookieDetails')}
          </button>
        </p>

        {showDetails && (
          <div className="cookie-details">
            <div className="cookie-detail-row">
              <div>
                <strong>{t('cookie.essential')}</strong>
                <span>{t('cookie.essentialDesc')}</span>
              </div>
              <span className="cookie-badge always">{t('cookie.alwaysOn')}</span>
            </div>
            <div className="cookie-detail-row">
              <div>
                <strong>{t('cookie.analytics')}</strong>
                <span>{t('cookie.analyticsDesc')}</span>
              </div>
              <span className="cookie-badge optional">{t('cookie.optional')}</span>
            </div>
            <div className="cookie-detail-row">
              <div>
                <strong>{t('cookie.advertising')}</strong>
                <span>{t('cookie.advertisingDesc')}</span>
              </div>
              <span className="cookie-badge optional">{t('cookie.optional')}</span>
            </div>
          </div>
        )}

        <div className="cookie-actions">
          <button className="btn btn-outline cookie-btn" onClick={acceptEssential}>
            {t('cookie.essentialOnly')}
          </button>
          <button className="btn btn-primary cookie-btn" onClick={accept}>
            {t('cookie.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
